import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  normalButton: {
    fontWeight: 'bold',
    width: '160px',
    borderRadius: '10px',
    color: theme.palette.primary.middleGray,
    backgroundColor: theme.palette.custom.outlineButtonBackground,
    border: `0.8px solid ${theme.palette.secondary.gray}`,
    '&:hover': {
      backgroundColor: theme.palette.custom.hoverSurface,
    },
  },
  blockButton: {
    fontWeight: 'bold',
    width: '160px',
    borderRadius: '10px',
    color: theme.palette.error.main,
    backgroundColor: theme.palette.custom.outlineButtonBackground,
    border: `0.8px solid ${theme.palette.error.main}`,
    '&:hover': {
      backgroundColor: theme.palette.error.light,
    },
  },
  dialogActions: {
    alignItems: 'center !important',
    justifyContent: 'center',
    paddingBottom: '20px',
  },
}));

export default useStyles;
